<template>
    <div class="main">
        <div class="back" @click="router.push('/carManage/cars')"> <a-button type="primary"><i
                    class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button></div>

        <!-- <tableItem :tableStatus="0" :tableObjTitle="tableTitle" :tableObjData="tableObj">
            <template v-slot:headTitle>
                车牌号：甘A 02922测
            </template>
</tableItem> -->

        <div class="mt60 formBox">
            <a-form ref="formRef" :model="form" name="basic" :rules="rules" :label-col="{ span: 7 }"
                :wrapper-col="{ span: 18 }">
                <a-form-item label="所属企业" :name="userStore.roles.includes('carEnterprise') ? deptIdStr : ''"
                    v-hasRole="['common']">
                    <a-select v-model:value="form.deptIdStr" placeholder="请输入" style="width: 100%">
                        <template v-for="item in deptList" :key="item.id">
                            <a-select-option :value="item.id">{{ item.name }}</a-select-option>
                        </template>

                    </a-select>
                </a-form-item>
                <a-form-item label="车辆品牌" name="carBrand">
                    <a-input v-model:value="form.carBrand" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="车辆型号" name="carModel">
                    <a-input v-model:value="form.carModel" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="车辆颜色" name="carColor">
                    <!-- <a-input v-model:value="form.carColor" placeholder="请输入" /> -->
                    <a-select ref="select" v-model:value="form.carColor" placeholder="请选择">
                        <template v-for="item in fuselageColorList" :key="item.dataCode">
                            <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="车辆类型" name="carType">
                    <!-- <a-input v-model:value="form.carType" placeholder="请输入" /> -->
                    <a-auto-complete v-model:value="form.carType" @select="completeSelect" :options="carTypeList"
                        placeholder="请选择" :filter-option="filterOption">
                        <template #option="item">
                            {{ item.value }}

                        </template>
                    </a-auto-complete>
                </a-form-item>
                <a-form-item label="自动驾驶级别" name="dynamicDriverLevel">
                    <!-- <a-input v-model:value="form.dynamicDriverLevel" placeholder="请输入" /> -->
                    <a-select ref="select" v-model:value="form.dynamicDriverLevel" placeholder="请选择">
                        <template v-for="item in driverLevelList" :key="item.dataCode">
                            <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="车架号" name="frameNum">
                    <a-input v-model:value="form.frameNum" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="发动机号" name="engineNum">
                    <a-input v-model:value="form.engineNum" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="车牌颜色" name="carPlateColor">
                    <!-- <a-input v-model:value="form.carPlateColor" placeholder="请输入" /> -->
                    <a-select ref="select" v-model:value="form.carPlateColor" placeholder="请选择">
                        <template v-for="item in plateColorList" :key="item.dataCode">
                            <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="能耗类型" name="energyType">
                    <a-input v-model:value="form.energyType" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="最大容量" name="maxCapacity">
                    <a-input v-model:value="form.maxCapacity" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="生产日期" name="produceDateStr">
                    <a-date-picker v-model:value="form.produceDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                        style="width: 100%;" />
                </a-form-item>
                <a-form-item label="车辆状态" name="carStatus">
                    <a-select ref="select" v-model:value="form.carStatus" placeholder="请选择">
                        <template v-for="item in carStatusList" :key="item.dataCode">
                            <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="最大设计总质量（kg）" name="maxDesignQuality">
                    <a-input v-model:value="form.maxDesignQuality" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="整车整备质量（kg）" name="totalQuality">
                    <a-input v-model:value="form.totalQuality" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="轴荷（kg）" name="alexLoad">
                    <a-input v-model:value="form.alexLoad" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="额定载客人数" name="ratedPassengerCapacity">
                    <a-input v-model:value="form.ratedPassengerCapacity" placeholder="请输入" />
                </a-form-item>
                <div class="flexItem">
                    <a-form-item label="动力型式">
                        <a-input v-model:value="form.dynamicModel" placeholder="请输入" />
                    </a-form-item>
                    <a-form-item label="生产企业">
                        <a-input v-model:value="form.dynamicModelManufacture" placeholder="请输入" />
                    </a-form-item>
                </div>
                <div class="flexItem">
                    <a-form-item label="发动机型号">
                        <a-input v-model:value="form.engineModel" placeholder="请输入" />
                    </a-form-item>
                    <a-form-item label="生产企业">
                        <a-input v-model:value="form.engineModelManufacture" placeholder="请输入" />
                    </a-form-item>
                </div>
                <div class="flexItem">
                    <a-form-item label="动力蓄电池型号">
                        <a-input v-model:value="form.dynamicBatteryManufacture" placeholder="请输入" />
                    </a-form-item>
                    <a-form-item label="生产企业">
                        <a-input v-model:value="form.dynamicBatteryModel" placeholder="请输入" />
                    </a-form-item>
                </div>
                <div class="flexItem">
                    <a-form-item label="动力电机型号">
                        <a-input v-model:value="form.dynamicMachineryModel" placeholder="请输入" />
                    </a-form-item>
                    <a-form-item label="生产企业">
                        <a-input v-model:value="form.dynamicMachineryManufacture" placeholder="请输入" />
                    </a-form-item>
                </div>
                <a-form-item label="监管装置">
                    <a-input v-model:value="computedModel" :disabled="true" />
                </a-form-item>
                <a-form-item label="车辆编码">
                    <a-input disabled v-model:value="form.testCarNum" placeholder="请获取资质后提交测试车牌号变更申请" />
                </a-form-item>
                <a-form-item label="编码申领日期" name="plateApplyDateStr">
                    <a-date-picker disabled v-model:value="form.plateApplyDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                        style="width: 100%;" />
                </a-form-item>
                <a-form-item label="编码到期日期" name="plateExpireDateStr">
                    <a-date-picker disabled v-model:value="form.plateExpireDateStr" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                        style="width: 100%;" />
                </a-form-item>






            </a-form>

            <div class="botmBtn">
                <a-button type="primary" ghost class="mr10" @click="cancel">取消</a-button>
                <a-button type="primary" class="ml10" @click="confirm">确定</a-button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, onMounted, watch, defineProps, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {
    addCar, editCar, detailById
} from "@/api/car/car.js";
import { getList } from '@/api/enterprise/index'
import useAppStore from "@/store/modules/app";
import useUserStore from '@/store/modules/user'
import { message } from 'ant-design-vue';
import { getSingleTypeValue, getSingleTypeCode } from "@/utils/matchDic.js";

const router = useRouter()
const route = useRoute()
const appStore = useAppStore();
const userStore = useUserStore();



const open = ref(false);
const formRef = ref();
const form = ref({
    deptIdStr: null,
    carBrand: "",
    carModel: "",
    carColor: null,
    carType: "",
    dynamicDriverLevel: null,
    frameNum: "",
    engineNum: "",
    carPlateColor: null,
    energyType: "",
    maxCapacity: "",
    produceDateStr: "",
    carStatus: null,
    maxDesignQuality: "",
    testCarNum: "",
    plateApplyDateStr: "",
    plateExpireDateStr: "",
    dynamicModel: "",
    dynamicModelManufacture: "",
    engineModel: "",
    engineModelManufacture: "",
    dynamicBatteryManufacture: "",
    dynamicBatteryModel: "",
    dynamicMachineryModel: "",
    dynamicMachineryManufacture: "",
    monitorDeviceId: "",
});

const reset = () => {
    form.value = {
        deptIdStr: null,
        carBrand: "",
        carModel: "",
        carColor: null,
        carType: "",
        dynamicDriverLevel: null,
        frameNum: "",
        engineNum: "",
        carPlateColor: null,
        energyType: "",
        maxCapacity: "",
        produceDateStr: "",
        carStatus: null,
        maxDesignQuality: "",
        testCarNum: "",
        plateApplyDateStr: "",
        plateExpireDateStr: "",
        dynamicModel: "",
        dynamicModelManufacture: "",
        engineModel: "",
        engineModelManufacture: "",
        dynamicBatteryManufacture: "",
        dynamicBatteryModel: "",
        dynamicMachineryModel: "",
        dynamicMachineryManufacture: "",
        monitorDeviceId: "",
    }
}

const rules = {
    deptIdStr: [
        { required: true, message: '所属企业不能为空', trigger: 'change' },
    ],
    carBrand: [
        { required: true, message: '车辆品牌不能为空', trigger: 'change' },
    ],
    name: [
        { required: true, message: '生产企业不能为空', trigger: 'change' },
    ],
    carModel: [
        { required: true, message: '车辆型号不能为空', trigger: 'change' },
    ],
    carColor: [
        { required: true, message: '车辆颜色不能为空', trigger: 'change' },
    ],
    carType: [
        { required: true, message: '车辆类型不能为空', trigger: 'change' },
    ],
    dynamicDriverLevel: [
        { required: true, message: '自动驾驶级别不能为空', trigger: 'change' },
    ],
    frameNum: [
        { required: true, message: '车架号不能为空', trigger: 'change' },
    ],
    engineNum: [
        { required: true, message: '发动机号不能为空', trigger: 'change' },
    ],
    carPlateColor: [
        { required: true, message: '车牌颜色不能为空', trigger: 'change' },
    ],
    energyType: [
        { required: true, message: '能耗类型不能为空', trigger: 'change' },
    ],
    maxCapacity: [
        { required: true, message: '最大容量不能为空', trigger: 'change' },
    ],
    produceDateStr: [
        { required: true, message: '生产日期不能为空', trigger: 'change' },
    ],
    carStatus: [
        { required: true, trigger: 'change', message: '车辆状态不能为空' },
    ],
    maxDesignQuality: [
        { required: true, trigger: 'change', message: '最大设计总质量不能为空' },
    ],
    

}

const computedModel = computed({
    get() {
        // 根据条件判断返回不同的值
        return form.value.bindMonitorDevice == '0' ? '未安装' : form.value.bindMonitorDevice == '1' ? '已安装' : '';
    },
    set(value) {
        form.value.bindMonitorDevice = value;
    }
});

if (route.query.id) {
    getData(route.query.id);
}

const filterOption = (input, option) => {
    return option.value.toUpperCase().indexOf(input.toUpperCase()) >= 0;
};

const dataCodeValue = ref('')
const completeSelect = (value, option) => {
    console.log(value);
    console.log(option);
    dataCodeValue.value = option.code

}

const deptList = ref([]);
function deptListAjax() {
    const query = {
        pageIndex: 1,
        pageSize: 500,
        conditionMap: {
            name: ''
        },
    };
    getList(query).then(res => {
        if (res.code == 200) {
            deptList.value = res.data.records;
        }
    })
}

deptListAjax();

//编辑模式下获取详情
function getData(id) {
    detailById({ id: id }).then(res => {
        console.log(res);
        if (res.code === 200) {
            res.data.carType = getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + res.data.carType)
            form.value = res.data;
            console.log(form.value);
            // console.log(getSingleTypeCode(appStore.SysDictVOList, 'carInfo' + 'category' + form.value.carType));
        }
    })
}

// 保存
const confirm = () => {
    console.log('保存');
    //车企端"deptIdStr"
    if (userStore.roles.includes('carEnterprise')) {
        form.value.deptIdStr = userStore.deptId;
    }
    formRef.value
        .validate()
        .then(() => {
            // console.log('values', form.value,);
            let obj = {
                ...form.value,
            }
            if (dataCodeValue.value) {
                form.value.carType = dataCodeValue.value
            } else {
                form.value.carType = getSingleTypeCode(appStore.SysDictVOList, 'carInfo' + 'category' + form.value.carType)
            }
            console.log(form.value);
            if (route.query.id) {
                //更新人id
                obj.updateBystr = '';
                editCar(form.value).then(res => {
                    if (res.code == 200) {
                        open.value = false;
                        message.success('保存成功');
                        router.push('/carManage/cars')
                    }
                })
            } else {
                //创建人id
                obj.createByStr = '';
                addCar(form.value).then(res => {
                    if (res.code == 200) {
                        open.value = false;
                        message.success('保存成功');
                        router.push('/carManage/cars')
                    }
                })
            }



        })
        .catch(error => {
            console.log('error', error);
        });
}
// 取消
const cancel = () => {
    console.log('取消');
    open.value = false;
    // formRef.value.resetFields();
    router.push('/carManage/cars')
}

const carStatusList = ref([]);
const fuselageColorList = ref([]);
const plateColorList = ref([]);
const carTypeList = ref([]);
const driverLevelList = ref([]);
onMounted(async () => {
    let carTypeArr = []
    carStatusList.value = await appStore.getSysDictVOList('车辆状态');
    fuselageColorList.value = await appStore.getSysDictVOList('车身颜色');
    plateColorList.value = await appStore.getSysDictVOList('车牌颜色');
    driverLevelList.value = await appStore.getSysDictVOList('自动驾驶级别');

    carTypeArr = await appStore.getSysDictVOList('车辆类型');
    carTypeArr.map(item => {
        carTypeList.value.push({
            value: item.dataValue,
            code: item.dataCode,
        })
    })

    console.log(carTypeList.value);
})
</script>
<style lang="less" scoped>
.main {
    padding: 20px;
    // height: calc(100vh - 70px - 57px);
    background-color: #ffffff;

    .back {
        position: fixed;
        top: 93px;
        right: 50px
    }

    .formBox {
        width: 50%;
        margin: 0 0 0 25%;

        .flexItem {
            display: flex;
            justify-content: space-around;

            /deep/.ant-form-item {
                width: 50%;

                .ant-col-6 {
                    flex: 0 0 50% !important;
                    max-width: 50% !important;
                }
            }
        }

        .botmBtn {
            display: flex;
            justify-content: center;

            .mr10 {
                margin-right: 5%;
                margin-left: 15%;
            }

            .ml10 {
                margin-left: 5%;
            }
        }
    }

}
/deep/.ant-input-disabled, .ant-input[disabled]{
    background: #ddd
}
</style>
